import OptionList from "../components/OptionList";
import { connect } from "react-redux";
import { byTitle } from "../reducer";
import { withRouter } from "react-router";
import { deleteCategory } from "../actions/category";

let mapStateToProps = state => {
  return {
    categories: state.categories
      .slice()
      .filter(c => c.type === "target" || c.type === "option")
      .sort(byTitle),
    options: state.options.slice().sort(byTitle)
  };
};

let mapDispatchToProps = dispatch => {
  return {
    deleteCategory: (id, reassignmentCategoryID) =>
      dispatch(deleteCategory(id, reassignmentCategoryID))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(OptionList)
);
